module.exports = __webpack_public_path__ + "img/Link_Logo.f65b234f.png";